module.exports = new __parcel__URL__("shop_machines_neon_gold_storage_v2.eddb66f7.png").toString();